function QuizQuestion({
  question,
  questionNumber,
  selectedAnswers,
  onAnswerChange,
  disabled,
  showResult,
  isCorrect,
}) {
  const handleSingleSelect = (optionId) => {
    if (disabled) return;
    onAnswerChange([optionId]);
  };

  const handleMultipleSelect = (optionId) => {
    if (disabled) return;
    const newSelected = selectedAnswers.includes(optionId)
      ? selectedAnswers.filter((id) => id !== optionId)
      : [...selectedAnswers, optionId];
    onAnswerChange(newSelected);
  };

  const renderOptions = () => {
    switch (question.questionType) {
      case "single":
      case "truefalse":
        return question.options.map((option, index) => (
          <div
            key={option.id}
            onClick={() => handleSingleSelect(option.id)}
            className={`quiz-option p-3 rounded-lg cursor-pointer transition-all ${
              disabled ? "cursor-not-allowed opacity-70" : "hover:bg-zinc-700/40"
            } ${selectedAnswers.includes(option.id) ? "bg-zinc-700/50" : "bg-transparent"}`}
            style={{
              border: selectedAnswers.includes(option.id)
                ? "1px solid rgba(165, 138, 194, 0.5)"
                : "1px solid transparent",
            }}
          >
            <span className="text-sm text-zinc-100">
              <span className="font-medium text-purple-300 mr-2">{String.fromCharCode(97 + index)}.</span>
              {option.text}
            </span>
          </div>
        ));

      case "multiple":
        return question.options.map((option, index) => (
          <div
            key={option.id}
            onClick={() => handleMultipleSelect(option.id)}
            className={`quiz-option p-3 rounded-lg cursor-pointer transition-all ${
              disabled ? "cursor-not-allowed opacity-70" : "hover:bg-zinc-700/40"
            } ${selectedAnswers.includes(option.id) ? "bg-zinc-700/50" : "bg-transparent"}`}
            style={{
              border: selectedAnswers.includes(option.id)
                ? "1px solid rgba(165, 138, 194, 0.5)"
                : "1px solid transparent",
            }}
          >
            <span className="text-sm text-zinc-100">
              <span className="font-medium text-purple-300 mr-2">{String.fromCharCode(97 + index)}.</span>
              {option.text}
            </span>
          </div>
        ));

      default:
        return null;
    }
  };

  return (
    <div
      className={`quiz-question py-4 mb-2 ${
        showResult
          ? isCorrect
            ? "border-green-500/30 bg-green-500/5"
            : "border-red-500/30 bg-red-500/5"
          : ""
      }`}
      style={{
        background: showResult
          ? isCorrect
            ? "rgba(134, 178, 122, 0.1)"
            : "rgba(239, 68, 68, 0.1)"
          : "transparent",
        borderBottom: showResult
          ? "none"
          : "1px solid rgba(113, 113, 122, 0.2)",
        borderRadius: showResult ? "8px" : "0",
        padding: showResult ? "16px" : undefined,
        border: showResult
          ? isCorrect
            ? "1px solid rgba(134, 178, 122, 0.3)"
            : "1px solid rgba(239, 68, 68, 0.3)"
          : undefined,
      }}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <span
            className="text-xs font-bold px-2 py-1 rounded"
            style={{
              background: "rgba(165, 138, 194, 0.2)",
              color: "rgba(200, 180, 220, 1)",
            }}
          >
            Q{questionNumber}
          </span>
          {question.questionType === "multiple" && (
            <span className="text-xs text-zinc-400 italic">
              (Select all that apply)
            </span>
          )}
        </div>
        {showResult && (
          <span
            className={`text-xs font-medium px-2 py-1 rounded ${
              isCorrect ? "text-green-400" : "text-red-400"
            }`}
            style={{
              background: isCorrect
                ? "rgba(134, 178, 122, 0.2)"
                : "rgba(239, 68, 68, 0.2)",
            }}
          >
            {isCorrect ? "✓ Correct" : "✗ Incorrect"}
          </span>
        )}
      </div>
      <p className="text-base text-white mb-4 font-medium">
        {question.questionText}
      </p>
      <div className="space-y-2">{renderOptions()}</div>
    </div>
  );
}

export default QuizQuestion;
